import * as Scrivito from "scrivito"
import { defaultPageAttributes } from "scrivito/Objs/shared/defaultAttributes"

export const DimConfigurationAdminPageObjClass = Scrivito.provideObjClass(
  "DimConfigurationAdminPage",
  {
    attributes: {
      ...defaultPageAttributes
    },
    extractTextAttributes: ["body"]
  }
)

export type DimConfigurationAdminPageObj = InstanceType<
  typeof DimConfigurationAdminPageObjClass
>
